class t extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="m15.263 7.73-3.405-5.805a.521.521 0 0 0-.45-.26h-6.81a.524.524 0 0 0-.451.26L.742 7.731a.531.531 0 0 0 0 .537l3.405 5.805a.522.522 0 0 0 .45.26h6.81a.523.523 0 0 0 .451-.26l3.405-5.805a.532.532 0 0 0 0-.537Zm-7.81-3.628h1.1V9.46h-1.1V4.1Zm.55 8.282a.735.735 0 0 1-.678-.451.728.728 0 0 1 .534-.997.736.736 0 0 1 .877.717.73.73 0 0 1-.734.73Z"></path></svg>';
  }
}
const e = "pi-warning-hex-filled";
customElements.get(e) || customElements.define(e, t);
export {
  t as default
};
